const reporting = {
  reportListLabels: {
    paymentRegister: "Payment Register",
    paymentMatchReport: "Payee Match Report",
    claimsReport: "Claims Report",
    creditorReport : "Creditor Report",
    contactsreports: "Contacts reports",
    claimItemReport: "Claim Item Report",
  },
  fileName:{
    creditor:"Creditor",
    contacts:"Contacts",
    claimItem:"ClaimItem",
  },
  reportTypeListLabels: {
    rbc: "RBC",
    desjardin: "Desjardin",
  },
  reportDropDownTitle: "Report Name",
  paymentRegisterStartDate: "Start Date",
  paymentRegisterEndDate: "End Date",
  reportTypeDropDownTitle: "Report Type",
  generateReport: "Generate Report",
  selectReport: "Select Report",
  reportRequired: "Select a Report",
  reportTypeRequired: "Select a Report Type",
  tableTitle: "Report Export History",
  tableDescription: "Previously run reports",
  tablePaymentRegisterDescription:"Previously ran payment reports",
  columnDetails: {
    column1: "Doc Name",

    column2: "File Number",

    column3: "Created By",

    column4: "Created Date",
    column5:"Status",
    column6: "Status Message",
  },
};

export default reporting;
